// @flow

// is logged in
export const UPDATE_USER = 'user:updateUser'
export type UPDATE_USER_TYPE = {
  type: 'user:updateUser',
  payload: { isLoggedIn: boolean }
}

export const updateUser = (isLoggedIn: boolean): UPDATE_USER_TYPE => ({
  type: UPDATE_USER,
  payload: { isLoggedIn }
})

// user permissions
export const PERMISSIONS_USER = 'user:permissionsUser'
export type PERMISSIONS_USER_TYPE = {
  type: 'user:permissionsUser',
  payload: { scope: string }
}

export const permissionsUser = (scope: string): PERMISSIONS_USER_TYPE => ({
  type: PERMISSIONS_USER,
  payload: { scope }
})



// WEBPACK FOOTER //
// ./src/actions/user/index.js